export default "__VITE_PUBLIC_ASSET__eaa679eb__"